import {Component, Input, OnInit} from '@angular/core';
import {
  CompetitorFormHelper,
  Country,
  Lookups,
} from "@model";
import {FormGroup} from "@angular/forms";
import {AbstractComponent} from "@components";

@Component({
    selector: 'app-team-members-management-form',
    templateUrl: './team-members-management-form.component.html',
    styleUrl: './team-members-management-form.component.scss',
    standalone: false
})
export class TeamMembersManagementFormComponent {
  @Input({ required: true }) inputForm: FormGroup | undefined;
  @Input({ required: true }) formHelper: CompetitorFormHelper | undefined;

}


export class LookupTeamMemberLists {
  countries: Country[] = [];
  tshirtSizes: Lookups[] = [];
  disciplines: Lookups[] = [];
  meals: Lookups[] = [];
  genders: Lookups[] = [];
  transports: Lookups[] = [];
  currencies: Lookups[] = [];

  constructor() {
  }
}
